<mat-toolbar color="primary">
    <mat-toolbar-row>
        <div class="title-font">DeckPlan</div>
        <span class="spacer"></span>
        <button mat-button routerLink="/login">Log in</button>
        <button mat-button (click)="goToHome()">Home</button>
        <button mat-button routerLink="/features">Features</button>
        <button mat-button routerLink="/pricing">Pricing</button>
        <button mat-button routerLink="/contact">Contact us</button>
        <button mat-icon-button (click)="openCardSearch()">
            <mat-icon>search</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>
